import React from "react"
import emojiReactionAnimation from "../../components/mediaPanel/small-view/reactions/emoji"

export const useHeartAnimation = (isSender: boolean) => {
  const setAnimationHeart = ({
    color,
    enabled
  }: {
    color: string
    enabled: boolean
  }) => {
    if (enabled && !isSender) {
      emojiReactionAnimation(color, "heart-icon")
    }
  }

  return {
    setAnimationHeart
  }
}
